import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FooterLinkComponent } from '../footer-link/footer-link.component';

@Component({
  selector: 'app-footer-third-column',
  imports: [FooterLinkComponent],
  templateUrl: './footer-third-column.component.html',
  styleUrl: './footer-third-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterThirdColumnComponent {}
